module.exports = __webpack_public_path__ + "static/media/tags.7c095b92.svg";